import React from "react";
import SupportCards from "./subComponents/SupportCards.component";
import { StyledHeader } from "./style/support.style";
const Support = () => {
  return (
    <div>
      <StyledHeader>
        <h2>Knowledge Base</h2>
        <p>Learn how to use Fixel and answer your most common questions.</p>
        <p>
          Didn’t find an answer? Shoot us an email at <a href="mailto:support@fixel.ai">support@fixel.ai</a>
        </p>
      </StyledHeader>
      <SupportCards />
    </div>
  );
};
export default Support;
